import { MotionProps } from "framer-motion";

import { SlideDirectionEnum } from "@typing/Enums";

export const fadeInAndOutMotionProps: MotionProps = {
  animate: { opacity: 1, transition: { delay: 0.5, duration: 0.5 } },
  exit: { opacity: 0, transition: { duration: 0.3 } },
  initial: { opacity: 0 }
};

export const fadeInMotionProps: MotionProps = {
  animate: { opacity: 1 },
  initial: { opacity: 0 },
  transition: { duration: 0.5 }
};

// This one is awfully specific to where its used (onboarding progress indicators), so it's probably
// not really reusable. It still seems maybe worthwhile to keep capturing all our animations in
// here, though.
export const growMotionProps: MotionProps = {
  animate: { padding: "0 3px", width: "19px" },
  exit: { padding: 0, width: 0 },
  initial: { padding: 0, width: 0 },
  transition: {
    padding: { duration: 1.2, ease: "linear", type: "tween" },
    width: { delay: 0.2, duration: 0.8, ease: "linear", type: "tween" }
  }
};

export const inflateMotionProps: MotionProps = {
  animate: { height: "5000px", width: "5000px" },
  exit: { height: "1px", width: "1px" },
  initial: { height: "1px", width: "1px" },
  transition: {
    height: { duration: 1.2 },
    width: { duration: 1.2 }
  }
};

export const levitateMotionProps: MotionProps = {
  animate: { y: 0 },
  exit: { y: 1000 },
  initial: { y: 1000 },
  transition: {
    y: { duration: 1.2, ease: "linear", type: "tween" }
  }
};

type GenerateSliderMotionPropsArgs = {
  direction: SlideDirectionEnum;
};

type GenerateSliderMotionProps = (args: GenerateSliderMotionPropsArgs) => MotionProps;

export const generateSliderMotionProps: GenerateSliderMotionProps = ({ direction }) => ({
  animate: { x: 0 },
  exit: { position: "absolute", x: direction === SlideDirectionEnum.LEFT ? 2000 : -2000 },
  initial: { x: direction === SlideDirectionEnum.RIGHT ? 1000 : -1000 },
  transition: {
    x: { bounce: 0.3, duration: 1, type: "spring" }
  }
});

export const slideHorizontalAnimation = (swipeDirection: "left" | "right") => ({
  animate: {
    opacity: 1,
    transition: { duration: 0.3, type: "tween" },
    x: 0
  },
  exit: {
    opacity: 0,
    transition: { duration: 0.3, type: "tween" },
    x: swipeDirection === "left" ? 300 : -300 // adjust values for off-screen exit
  },
  initial: {
    opacity: 0,
    transition: { duration: 0.3, type: "tween" },
    x: swipeDirection === "left" ? -300 : 300 // adjust values for off-screen start
  }
});

export const fadeAnimation = {
  animate: { duration: 0.3, opacity: 1 },
  exit: { duration: 0.3, opacity: 0 },
  initial: { duration: 0.3, opacity: 0 }
};
